import {
  IPriceResource
} from 'modules/common/price/price.types';

export const PRICE_BLANK: IPriceResource = {
  currency: null,
  fare: null,
  tax: null,
  total: null
}